import { ToastOptions } from 'react-toastify'

export const TOAST_OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  theme: 'colored',
  className: '',
  closeOnClick: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
}
